module.exports = __webpack_public_path__ + "static/media/banco-pan-logo-cinza@3x.629e9fcc.jpg";